export default __webpack_public_path__ + "static/media/table-size-default.e6ae2b3c.svg";